/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

export const ACTIONS = {
  StartVoiceChat: 'StartVoiceChat',
  UpdateVoiceChat: 'UpdateVoiceChat',
  StopVoiceChat: 'StopVoiceChat',
  SpeakText: 'SpeakText',
};
